export const wrapperInventoryControl = {
	titleWrapper: "Crear nuevo inventario",
	titleButtons: {
		sendInventory: "Enviar inventario",
		approveInventory: "Aprobar inventario",
		retellInventory: "Recontar",
		downloadInExcel: "Descargar en excel",
	},
	placeholders: {
		keywordSearch: "Buscar por categoría, código o producto",
	},
	headerInfos: {
		name: "Nombre",
		inventoryTitle: "Título del inventario",
		createAt: "Fecha de creación",
		lastEdtion: "Última edición",
		detailsInventory: "Detalles del inventario",
		stockist: "Almacenista",
		totalProducts: "Total de productos",
		categoriesSelected: "Categorías seleccionadas",
		storageSelected: "Inventario seleccionado",
		storageAndCategoriesSelected: "Inventario y categorías",
		status: "Estado",
	},
	seeMoreDetails: "Ver más detalles",
	drawerInfos: {
		seeDetails: "Ver detalles",
	},
};
